export const featureIsExpired = (validity) => {
  const currentDate = new Date();
  const validityDate = new Date(validity);
  return validity == null || currentDate > validityDate;
};
